export const customerSettings = {
  '100': { // ETE
    spedLogo: 'https://assets.bdk-software.ch/images/logos/HeaderETE.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgeteprov.jpg',
    mainColor: '#737373',
    mainConstrastColor: '#ffffff',
    highlightColor: '#FADC00',
    highlightContrastColor: '#424242',
    panelHeaderColor: '#737373'
  },
  '101': { // Fattorini
    spedLogo: 'https://fattorini.ch/wp-content/uploads/2019/08/s5_logo.png',
    spedImage: 'https://fattorini.ch/wp-content/uploads/2019/08/background2.jpg',
    mainColor: '#424242',
    mainConstrastColor: '#ffffff',
    highlightColor: '#f8d817',
    highlightContrastColor: '#40A02A',
    panelHeaderColor: '#424242'
  },
  '1044': { // BDK Backup
    spedLogo: 'https://assets.bdk-software.ch/images/logos/HeaderBdk.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/BgBDKbunt.jpg',
    mainColor: '#2196f3',
    mainConstrastColor: '#ffffff',
    highlightColor: '#ff9800',
    highlightContrastColor: '#424242',
    panelHeaderColor: '#2196f3'
  },
  '103': { // Felix
    spedLogo: 'https://assets.bdk-software.ch/images/logos/HeaderFelix.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgFelix.jpg',
    mainColor: '#ffffff',
    mainConstrastColor: '#000000',
    highlightColor: '#BD0019',
    highlightContrastColor: '#FFFFFF',
    panelHeaderColor: '#e1e0e0'
  },
  '104': { // Rueedi
    spedLogo: 'https://assets.bdk-software.ch/images/logos/HeaderRueedi.jpg',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgRueedi.jpg',
    mainColor: '#68B022',
    mainConstrastColor: '#ffffff',
    highlightColor: '#68B022',
    highlightContrastColor: '#ffffff',
    panelHeaderColor: '#68B022'
  },
  '106': { // Hasler Transport Weinfelden
    spedLogo: 'https://www.haslertransport.ch/templates/tmpl_std/hasler-transport-weinfelden-neu.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgHaslerWeinfelden.jpg',
    mainColor: '#b9b393',
    mainConstrastColor: '#000000',
    highlightColor: '#ee1c25',
    highlightContrastColor: '#000000',
    panelHeaderColor: '#f3f2f2'
  },
  '107': { // Bättig
    spedLogo: 'https://assets.bdk-software.ch/images/logos/headerBaettig.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgBaettig.jpg',
    mainColor: '#ffffff',
    mainConstrastColor: '#004A99',
    highlightColor: '#004A99',
    highlightContrastColor: '#ffdc00',
    panelHeaderColor: '#e1e0e0'
  },
  '108': { // Lagerhäuser Aarau
    spedLogo: 'https://www.la-aarau.ch/fileadmin/themes/theme_tesla/la_aarau/gui/Lagerhauser-Aarau-Logo.svg',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bglha.jpg',
    mainColor: '#ffffff',
    mainConstrastColor: '#000000',
    highlightColor: '#ED1C24',
    highlightContrastColor: '#000000',
    panelHeaderColor: '#e1e0e0'
  },
  '109': { // Hasler Logistik Rüthi
    spedLogo: 'https://www.haslerlogistik.ch/templates/tmpl_std/hasler-logistik.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgHaslerRuethi.jpg',
    mainColor: '#01883e',
    mainConstrastColor: '#ffffff',
    highlightColor: '#ee1c25',
    highlightContrastColor: '#000000',
    panelHeaderColor: '#01883e'
  },
  '110': { // Brauch
    spedLogo: 'https://assets.bdk-software.ch/images/logos/HeaderBrauch.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgBrauch.jpg',
    mainColor: '#0096D7',
    mainConstrastColor: '#ffffff',
    highlightColor: '#0096D7',
    highlightContrastColor: '#000000',
    panelHeaderColor: '#e1e0e0'
  },
  '111': { // Häfliger
    spedLogo: 'https://assets.bdk-software.ch/images/logos/HeaderHaefliger.jpg',
    spedImage: 'https://i.ytimg.com/vi/NQHYdDr3bd8/maxresdefault.jpg',
    mainColor: '#ffffff',
    mainConstrastColor: '#424242',
    highlightColor: '#DF0454',
    highlightContrastColor: '#ffffff',
    panelHeaderColor: '#e1e0e0'
  },
  '113': { // Hunziker
    spedLogo: 'https://assets.bdk-software.ch/images/logos/HeaderHunziker.jpg',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgHunziker.jpg',
    mainColor: '#ffffff',
    mainConstrastColor: '#000000',
    highlightColor: '#FFDD00',
    highlightContrastColor: '#000000',
    panelHeaderColor: '#e1e0e0'
  },
  '115': { // Steiner
    spedLogo: 'https://assets.bdk-software.ch/images/logos/HeaderSteinerStoll.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgStoll.jpg',
    mainColor: '#ffffff',
    mainConstrastColor: '#000000',
    highlightColor: '#9b1b2b',
    highlightContrastColor: '#000000',
    panelHeaderColor: '#e1e0e0'
  },
  '116': { // Woodlog
    spedLogo: 'https://assets.bdk-software.ch/images/logos/headerWoodlog.jpg',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgWoodlog.jpg',
    mainColor: '#ffffff',
    mainConstrastColor: '#779628',
    highlightColor: '#779628',
    highlightContrastColor: '#ffffff',
    panelHeaderColor: '#e1e0e0'
  },
  '118': { // Aletsch Bahnen
    spedLogo: 'https://assets.bdk-software.ch/images/logos/HeaderTransEx.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgTransEx.jpg',
    mainColor: '#ffffff',
    mainConstrastColor: '#000000',
    highlightColor: '#CE0000',
    highlightContrastColor: '#000000',
    panelHeaderColor: '#e1e0e0'
  },
  '119': { // Transex
    spedLogo: 'https://assets.bdk-software.ch/images/logos/HeaderTransEx.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgTransEx.jpg',
    mainColor: '#ffffff',
    mainConstrastColor: '#000000',
    highlightColor: '#CE0000',
    highlightContrastColor: '#000000',
    panelHeaderColor: '#e1e0e0'
  },
  '120': { // Stoll
    spedLogo: 'https://assets.bdk-software.ch/images/logos/HeaderSteinerStoll.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgStoll.jpg',
    mainColor: '#ffffff',
    mainConstrastColor: '#424242',
    highlightColor: '#2196f3',
    highlightContrastColor: '#000000',
    panelHeaderColor: '#e1e0e0'
  },
  '122': { // Mathys
    spedLogo: 'https://assets.bdk-software.ch/images/logos/headerMathys.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgMathys.jpg',
    mainColor: '#e1e0e0',
    mainConstrastColor: '#424242',
    highlightColor: '#FFDD00',
    highlightContrastColor: '#000000',
    panelHeaderColor: '#e1e0e0'
  },
  '123': { // Beny Landolt
    spedLogo: 'https://assets.bdk-software.ch/images/logos/headerCityTrans.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgCityTrans.jpg',
    mainColor: '#128812',
    mainConstrastColor: '#ffffff',
    highlightColor: '#128812',
    highlightContrastColor: '#ffffff',
    panelHeaderColor: '#e1e0e0'
  },
  '124': { // Duenki
    spedLogo: 'https://assets.bdk-software.ch/images/logos/DuenkiLogoBlauElog.jpg',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgDuenki.jpg',
    mainColor: '#005b9a',
    mainConstrastColor: '#424242',
    highlightColor: '#005b9a',
    highlightContrastColor: '#FFFFFF',
    panelHeaderColor: '#e1e0e0'
  },
  '126': { // Cargo 24
    spedLogo: 'https://assets.bdk-software.ch/images/logos/HeaderSteinerStoll.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgHaslerWeinfelden.jpg',
    mainColor: '#ffffff',
    mainConstrastColor: '#424242',
    highlightColor: '#2196f3',
    highlightContrastColor: '#000000',
    panelHeaderColor: '#e1e0e0'
  },
  '128': { // Transstahl
    spedLogo: 'https://assets.bdk-software.ch/images/logos/HeaderTransstahl.png',
    spedImage: 'https://www.transstahl.ch/assets/images/0/Luft_02-e1d8cf74.jpg',
    mainColor: '#ffffff',
    mainConstrastColor: '#424242',
    highlightColor: '#3C72B7',
    highlightContrastColor: '#000000',
    panelHeaderColor: '#e1e0e0'
  },
  '130': { // Swissmed
    spedLogo: 'https://assets.bdk-software.ch/images/logos/HeaderSwissMed.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgSwissMed.jpg',
    mainColor: '#ffffff',
    mainConstrastColor: '#58585a',
    highlightColor: '#97BF0D',
    highlightContrastColor: '#000000',
    panelHeaderColor: '#e1e0e0'
  },
  '131': { // Bregy
    spedLogo: 'https://assets.bdk-software.ch/images/logos/headerBregy.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgBregy.jpg',
    mainColor: '#05468a',
    mainConstrastColor: '#ffffff',
    highlightColor: '#05468a',
    highlightContrastColor: '#F9B415',
    panelHeaderColor: '#05468a'
  },
  '135': { // Beo Logistik
    spedLogo: 'http://assets.bdk-software.ch/images/logos/HeaderBeo.png',
    spedImage: 'http://assets.bdk-software.ch/images/backgrounds/bgBeo.jpg',
    mainColor: '#ffffff',
    mainConstrastColor: '#24B6B7',
    highlightColor: '#24B6B7',
    highlightContrastColor: '#ffffff',
    panelHeaderColor: '#CCCCCC'
  },
  '137': { // Traveco
    spedLogo: 'https://assets.bdk-software.ch/images/logos/HeaderTraveco.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgTraveco.jpg',
    mainColor: '#ffffff',
    mainConstrastColor: '#00852a',
    highlightColor: '#00852a',
    highlightContrastColor: '#ffffff',
    panelHeaderColor: '#CCCCCC'
  },
  '138': { // Guyan Transport
    spedLogo: 'https://assets.bdk-software.ch/images/logos/headerGuyan.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgGuyan.jpg',
    mainColor: '#ffffff',
    mainConstrastColor: '#003399',
    highlightColor: '#ffffff',
    highlightContrastColor: '#003399',
    panelHeaderColor: '#003399'
  },
  '102': { // CityTrans
    spedLogo: 'https://assets.bdk-software.ch/images/logos/headerCityTrans.png',
    spedImage: 'https://assets.bdk-software.ch/images/backgrounds/bgCityTrans.jpg',
    mainColor: '#ffffff',
    mainConstrastColor: '#000000',
    highlightColor: '#FF0000',
    highlightContrastColor: '#ffffff',
    panelHeaderColor: '#e1e0e0'
  },
  '237': { // Traveco
    spedLogo: 'https://assets.bdk-software.ch/images/logos/HeaderTraveco.png',
    spedImage: '',
    mainColor: '#ffffff',
    mainConstrastColor: '#00852a',
    highlightColor: '#00852a',
    highlightContrastColor: '#ffffff',
    panelHeaderColor: '#CCCCCC'
  }
}
